
import { MediaMessage } from '@/common/bot/types/messages/MediaMessage';
import LightBox from '@/components/Lightbox.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

// TODO: Refactor Me Later
@Component({ components: { LightBox } })
export default class ChatMedia extends Vue {
  @Prop({ default: () => ({}) }) message!: MediaMessage;
  get isImage () {
    return /^image/.test(this.message.attachment.mimeType);
  }
}
